import {
  AGGREGATOR_ORDER_META,
  normalizeAggregatorCode,
} from "./aggregatorPresentation";
import { normalizeOptionalCatalogPrice } from "./catalogPrice";

export const readAggregatorPrice = (entity, aggregatorCode) => {
  const code = normalizeAggregatorCode(aggregatorCode);
  if (!code || !entity) return null;
  const field = AGGREGATOR_ORDER_META[code]?.priceField;
  if (!field) return null;
  const value = normalizeOptionalCatalogPrice(entity[field]);
  return value !== null && value >= 0 ? value : null;
};
